import { View } from 'react-native'

import { styled } from '~/utils/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      paddingTop: theme.paddingInsetTwopulse,
      paddingBottom: theme.paddingInsetTwopulse,
      paddingRight: theme.paddingInsetFourpulse,
      paddingLeft: theme.paddingInsetFourpulse,
      gap: theme.spacingInlineTwopulse,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: 'white',
    },
  }
})

export const ProgressIndicatorContainer = styled(View, theme => {
  return {
    base: {},
  }
})
